import WidgetsIcon from "@mui/icons-material/Widgets";
import {useAuthorizedViaAdmin} from "crqlar-react-common/dist/utils/hooks/admin/useAuthorizedViaAdmin";
import {useLocalize} from "crqlar-react-common/dist/utils/text.util";
import {useEffect, useState} from "react";
import {Navigate, Outlet, useLocation} from "react-router-dom";
import type {TabRoute} from "../layout/PageShell";
import {PageShell} from "../layout/PageShell";

function BookingEngine() {
    const {t} = useLocalize();
    const {pathname} = useLocation();
    const isAuthorizedViaAdmin = useAuthorizedViaAdmin();
    const [authorizationResolved, setAuthorizationResolved] = useState(
        process.env.NODE_ENV === "development",
    );

    useEffect(() => {
        setAuthorizationResolved(true);
    }, []);

    if (pathname.startsWith("/bookingEngine/insights") && !authorizationResolved) {
        return null;
    }

    if (!isAuthorizedViaAdmin && pathname.startsWith("/bookingEngine/insights")) {
        return <Navigate replace to="/bookingEngine/configurations"/>;
    }

    const tabs: TabRoute[] = [
        {
            path: "/bookingEngine/configurations",
            label: t("Booking Engines"),
            render: () => <Outlet/>,
        },
        // ...(isAuthorizedViaAdmin
        //     ? [{
        //         path: "/bookingEngine/insights",
        //         label: t("Insights"),
        //         render: () => <Outlet/>,
        //     }]
        //     : []),
    ];

    return (
        <PageShell
            icon={<WidgetsIcon fontSize="inherit"/>}
            title={t("Booking engine")}
            documentTitle={t("Booking engine")}
            tabs={tabs}
        />
    );
}

export default BookingEngine;
